import useAxios from 'axios-hooks';
import { IDebin } from '../../types/IDebin';
import { UrlsBack } from '../../constants/urls';

/** Hook para obtener los datos de un DEBIN a partir de un
 *  id de DEBIN
 **/
export const useGetDebin = () => {
  const [{ data, loading }, request] = useAxios<IDebin>('', { manual: true });

  const getDebin = (id: string | number) => {
    return request(`${UrlsBack.DebinInfo}/${id}`);
  };
  return [getDebin, data, loading] as const;
};
